var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEllipse75 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 220,
  height: 210,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#B7D523",
  d: "M-114.998 57.456A195.807 195.807 0 0 1 219.264 195.91a195.8 195.8 0 0 1-57.35 138.456L75.367 247.82A73.41 73.41 0 1 0-28.451 144.003z"
})));
export { SvgEllipse75 as ReactComponent };
export default __webpack_public_path__ + "ffc6827a246f674b3b10b899194e9aaf.svg";